






































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CardComponent extends Vue {
  @Prop({
    default: null,
  })
  public title!: string;

  @Prop({
    default: null,
  })
  public icon!: string;

  @Prop({
    default: null,
  })
  public headerIcon!: string;

  public headerIconClick(): void {
    this.$emit('header-icon-click');
  }
}
